import PropTypes from "prop-types"
import Link from "../../UI/Link/Link"

export const DropdownLinksCollectionPropTypes = PropTypes.shape({
    __typename: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape(Link.propTypes)),
})

export const MenuElementPropTypes = PropTypes.shape({
    __typename: PropTypes.string,
    sys: PropTypes.shape({
        id: PropTypes.string,
    }),
    link: PropTypes.shape(Link.propTypes),
    dropdownLinksCollection: DropdownLinksCollectionPropTypes,
})
export const MenuElementOrLinkPropTypes = PropTypes.oneOfType([MenuElementPropTypes, PropTypes.shape(Link.propTypes)])

export const MenuDropdownElementPropTypes = {
    menuElement: MenuElementPropTypes,
    style: PropTypes.object,
}

export const HeaderPropTypes = {
    logo: PropTypes.shape({
        url: PropTypes.string,
        width: PropTypes.number,
        height: PropTypes.number,
        title: PropTypes.string,
    }),
    menuElementsCollection: PropTypes.shape({
        items: PropTypes.arrayOf(MenuElementOrLinkPropTypes),
    }),
    mainCta: PropTypes.object,
}
